import Enlang from "./entries/en_US";
import Ellang from "./entries/el_GR";

const Locale = {
  en: Enlang,
  el: Ellang,
};

export default Locale;
